(function() {
  angular
  .module('meanApp')
  .factory('allergensManager', allergensManager);

  allergensManager.$inject = ["Allergen", "modelManager"];
  function allergensManager (Allergen, modelManager) {
		return angular.extend({}, modelManager.init(Allergen));
  };

})();